<template>
  <div id="blur" />
  <div id="confirm">
    <div v-if="isSelfBook" class="inner">
      <h3>Your trip booking is processing</h3>
      <p>We will send you a confirmation email once your itinerary is fully booked and confirmed.</p>
      <p>If you need support, please contact us below.</p>
    </div>
    <div v-else class="inner">
      <h3>Your trip request is submitted</h3>
      <p>We will send you an email as soon as we review your request with questions or a suggested itinerary.</p>
      <p>If you need support, please contact us below.</p>
    </div>
    <router-link v-slot="{ route, navigate }" :to="{ name: 'trips' }">
      <button :route="route" @click="navigate">Return to Dashboard</button>
    </router-link>
    <div>
      <router-link :to="{ name: 'trip', params: { tripId: tripId } }"> Or, contact support now. </router-link>
    </div>
  </div>
</template>

<script setup>
defineProps(["isSelfBook", "tripId"]);
</script>

<style lang="less">
#confirm {
  background: @light;
  border-radius: 1rem;
  margin: auto;
  max-width: 30rem;
  padding: 2rem;
  text-align: center;
  position: relative;

  z-index: 2000;

  p {
    margin: 1rem auto 0;
    max-width: 24rem;
    text-align: left;
  }

  button {
    margin-bottom: 1rem;
  }

  .inner {
    margin-bottom: 2rem;
  }
}
</style>
